/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { Credential11 } from './Credential11';

export const CredentialDataModel: core.serialization.Schema<
    serializers.CredentialDataModel.Raw,
    Truvity.CredentialDataModel
> = core.serialization
    .union(core.serialization.discriminant('flavorName', 'flavor_name'), {
        VC1_1: Credential11,
    })
    .transform<Truvity.CredentialDataModel>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace CredentialDataModel {
    export type Raw = CredentialDataModel.Vc11;

    export interface Vc11 extends Credential11.Raw {
        flavor_name: 'VC1_1';
    }
}
